import React from 'react';
import { Text } from './Typography';
import styles from './Button.scss';
import { Loader } from './Loader';
export const Button = ({ children, onClick, textProps = {}, inverted, loading = false, disabled = false, wide = false, color, type = 'submit', }) => {
    const buttonStyle = color
        ? {
            backgroundColor: color,
            borderColor: color,
        }
        : {};
    return (React.createElement("button", { type: type, onClick: onClick, className: `${styles.button} ${inverted ? styles.inverted : ''} ${color ? styles.decorated : ''} ${wide ? styles.wide : ''}`, disabled: disabled, style: buttonStyle }, loading ? (React.createElement("div", { style: {
            padding: '11px 16px',
            display: 'flex',
            justifyContent: 'center',
        } },
        React.createElement(Loader, { inverted: inverted }))) : (React.createElement("div", { style: { padding: '11px 16px' } },
        React.createElement(Text, { ...textProps }, children)))));
};
//# sourceMappingURL=Button.js.map